module.exports = __webpack_public_path__ + "img/IMG_3346_2028_T_FoamcoreMatted.8a9e99e5.jpg";